/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type RemoteActionJobUpdateDto = {
  /**
   * New status for remote action job
   */
  status: RemoteActionJobUpdateDto.status;
};
export namespace RemoteActionJobUpdateDto {
  /**
   * New status for remote action job
   */
  export enum status {
    CANCELLATION_IN_PROGRESS = 'CANCELLATION_IN_PROGRESS',
  }
}

